/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
const dd = require("ES/lib/dd");
const _ = require("ES/lib/lodash");
const esUtils = require("ES/utils/esUtils");
let ImportEvent = require("../../../ImportEvent.js");

module.exports = dd.createClass({
  mixins: [],
  getInitialState: function () {
    return { show_form: false };
  },

  __toggleForm: esUtils.wrapPreventDefault(function () {
    this.setState({ show_form: !this.state.show_form });
  }),
  render: function () {
    let event = this.props.event;
    let Displaylists = this.props.Displaylists;

    return this.state.show_form
      ? dd.div(
          { className: "panel panel-default" },
          dd.div(
            { className: "panel-body" },
            dd.h4(
              { className: "section-head", style: { marginTop: 0 } },
              "Link HighLevel Opportunity"
            ),
            ImportEvent({
              Displaylists: Displaylists,
              service_to_import_from: "hl",
              link_to_event: event,
            })
          )
        )
      : dd.p(
          null,
          dd.button(
            {
              disabled: !_.isEmpty(_.get(event, "foreignKey")),
              className: "btn btn-default",
              style: { marginTop: "1rem" },
              onClick: this.__toggleForm,
            },
            "Link HighLevel Opportunity"
          )
        );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/event_actions/LinkOpportunityHighlevel.js